// extracted by mini-css-extract-plugin
module.exports = {"container":"a630f0e637--container--C8WMp","text":"a630f0e637--text--ae2Cq"};